export default __webpack_public_path__ + "static/media/AdGhosts_04.88872046.png";